class ResultCloudResultSet
{
    /**
     * @param response
     */
    map = (response) => response.answers.map((answer) => answer.answer);

    /**
     * @param response
     */
    fromResponse = (response) => this.map(response).map((item) => JSON.parse(item).value);
}

export default new ResultCloudResultSet();
